import React from 'react';
import { InfoWindow, Marker } from '@react-google-maps/api';
import _get from 'lodash/get';

const MarkerCustom = (props) => {
  const {
    onClick = () => {},
    index = 0,
    stop = null,
    clusterer,
    selectedMarker,
    visible = true,
    isStartOrDestination,
    mainColor,
    routeName = '',
  } = props;

  const truckIcon = `
    <g style="transform: translate(8px, 5px);" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Transport" transform="translate(0.000000, -48.000000)" fill-rule="nonzero">
        <g id="truck_fill" transform="translate(0.000000, 48.000000)">
          <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero">
          </path>
          <path d="M15,4 C16.1046,4 17,4.89543 17,6 L17,7 L18.5194,7 C19.1269,7 19.7016,7.27618 20.0811,7.75061 L21.5617,9.6014 C21.8454,9.956 22,10.3966 22,10.8508 L22,15 C22,16.1046 21.1046,17 20,17 L19,17 C19,18.6569 17.6569,20 16,20 C14.3431,20 13,18.6569 13,17 L10,17 C10,18.6569 8.65685,20 7,20 C5.34315,20 4,18.6569 4,17 C2.89543,17 2,16.1046 2,15 L2,6 C2,4.89543 2.89543,4 4,4 L15,4 Z M7,16 C6.44772,16 6,16.4477 6,17 C6,17.5523 6.44772,18 7,18 C7.55228,18 8,17.5523 8,17 C8,16.4477 7.55228,16 7,16 Z M16,16 C15.4477,16 15,16.4477 15,17 C15,17.5523 15.4477,18 16,18 C16.5523,18 17,17.5523 17,17 C17,16.4477 16.5523,16 16,16 Z M18.5194,9 L17,9 L17,13 L20,13 L20,10.8508 L18.5194,9 Z" fill="#fff">
          </path>
        </g>
      </g>
    </g>
  `;

  const flagIcon = `
    <g>
      <path d="M4.5 21V16M4.5 16V6.5C5.5 5.5 7 5 8.5 5C11.5 5 13.5 7.5 17.5 5.5V15.5C13.5 17.5 11.5 14.5 8.5 14.5C7.5 14.5 5.5 15 4.5 16Z" stroke="#fff" fill="#fff" stroke-linecap="round" stroke-linejoin="round" style="transform: translate(10px, 5px);"/>
    </g>
  `;

  const iconStartOrDes = stop?.status === 'start' ? truckIcon : flagIcon;
  const order = _get(stop, 'order', '');

  const isSelectedMarker =
    JSON.stringify({ routeName, stopIndex: index }) ===
    JSON.stringify({
      routeName: selectedMarker?.routeName,
      stopIndex: selectedMarker?.stopIndex,
    });

  const urlMarker = `
    <svg width="30" height="30" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
      <g>
        <path style="fill:#${mainColor?.replace(
          '#',
          ''
        )};" d="M19.999,38.251C17.896,35.874,7.5,23.628,7.5,14C7.5,7.107,13.107,1.5,20,1.5S32.5,7.107,32.5,14
        C32.5,23.58,22.102,35.866,19.999,38.251z"/>
        <path style="fill:#667085;" d="M20,2c6.617,0,12,5.383,12,12c0,8.932-9.29,20.349-12.001,23.491C17.286,34.358,8,22.977,8,14
        C8,7.383,13.383,2,20,2 M20,1C12.82,1,7,6.82,7,14c0,10.981,13,25,13,25s13-14.074,13-25C33,6.82,27.18,1,20,1L20,1z"/>
        ${
          !isStartOrDestination ? (
            `<text font-size="${order < 100 ? '13px' : '12px'}"
              fill="#fff"
              font-family="Verdana"
              text-anchor="middle"
              alignment-baseline="baseline"
              font-weight="700"
              x="20"
              y="20"
            >
              ${order}
            </text>`
          ) : null
        }
      </g>
      ${
        isStartOrDestination ? (
          `
            ${iconStartOrDes}
          `
        ) : null
      }
    </svg>`;

  return (
    <Marker
      visible={order !== null}
      icon={{
        url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(urlMarker),
        // anchor: new window.google.maps.Point(0, 0),
      }}
      // label={{
      //   text: `${order}`,
      //   color: '#fff',
      //   fontSize: '12px',
      //   fontWeight: '700',
      //   className: isStartOrDestination ? 'd-none' : '',
      // }}
      onClick={onClick}
      position={{ lat: _get(stop, 'lat', 0), lng: _get(stop, 'lng', 0) }}
      clusterer={clusterer}
      zIndex={isSelectedMarker ? 9999 : index}
      opacity={visible || isSelectedMarker ? 1 : 0}
      animation={isSelectedMarker && window.google.maps.Animation.BOUNCE}
    >
      {selectedMarker === stop && (
        <InfoWindow>
          <div style={{ color: 'black' }}>Shop</div>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default MarkerCustom;
